import { colors } from 'src/constants';
import { PermissionApiName } from 'src/types';
import { TapTapFiltersV2, TapTapQuickFilterView } from '../types';
import { taptapCustomerField } from './taptap-fields';
import {
  quickFilterCashierDefaultColumns,
  quickFilterForBuildDefaultColumns,
  quickFilterReleasingDefaultColumns,
  quickFilterViewsLabels,
  taptapCustomerInitialPayload
} from './taptap-filters';

export const taptapSourceV2 = {
  FACEBOOK: 'FACEBOOK',
  VIBER: 'VIBER',
  ECOMM: 'ECOMM',
  WALK_IN: 'WALK IN',
  ONLINE: 'ONLINE'
};

const taptapCouriers = {
  PICK_UP: 'PICK UP',
  JNT: 'JNT',
  TECHOUT: 'TECHOUT',
  LALAMOVE: 'LALAMOVE',
  COD_TECHOUT: 'COD-TECHOUT'
};

//create sales customer taptap as reserved transaction
export const TAG_AS_RESERVED = 'FOR RESERVED';

const taptapServiceType = {
  PARTS_OUT: 'PARTS OUT',
  FOR_BUILD: 'FOR BUILD',
  LAPTOP: 'LAPTOP',
  MONITOR: 'MONITOR',
  ADDITIONAL_PURCHASE: 'ADDITIONAL PURCHASE',
  SALES_TRANSFER: 'SALES TRANSFER',
  BUILD_SALES_TRANSFER: 'BUILD SALES TRANSFER',
  PARTS_OUT_SALES_TRANSFER: 'PARTS OUT SALES TRANSFER',
  BUILD_TRANSFER_BRANCH_RECEIVING: ' BUILD (SALES TRANSFER) BRANCH RECEIVING',
  BUILD_TRANSFER_BRANCH_DISPATCHING:
    ' BUILD (SALES TRANSFER) BRANCH DISPATCHING',
  PARTS_OUT_TRANSFER_BRANCH_RECEIVING:
    ' PARTS OUT (SALES TRANSFER) BRANCH RECEIVING',
  PARTS_OUT_TRANSFER_BRANCH_DISPATCHING:
    ' PARTS OUT (SALES TRANSFER) BRANCH DISPATCHING',
  BUILD_RMA_DIFFERENT_PC_PARTS_WT_ADD_COST:
    'BUILD RMA (DIFFERENT PC PARTS but additional cost)',
  BUILD_RMA_SAME_PC_PARTS: 'BUILD RMA (SAME PC PARTS)',
  BUILD_RMA_DIFFERENT_PC_PARTS_WT_REFUND:
    'BUILD RMA (DIFFERENT PC PARTS but refund some)'
};

export const taptapStatuses = {
  HOLD: 'HOLD', // sinong department ang maghohold hmmmmmm
  FOR_CHECKING: 'FOR CHECKING',

  //SALES
  FOR_PAYMENT: 'FOR PAYMENT',
  READY_FOR_PICKUP: 'READY FOR PICKUP',

  //ACCOUNTING
  DONE_PAYMENT: 'DONE PAYMENT',
  REFUND: 'REFUND',
  ONLINE_FUND_TRANSFER: 'ONLINE FUND TRANSFER',
  PAYMENT_COLLECTION: 'PAYMENT COLLECTION',

  // //WAREHOUSE
  FOR_PACKING: 'FOR PACKING',
  READY_FOR_DELIVERY: 'READY FOR DELIVERY',
  RESERVED: 'RESERVED',
  PREPARING_ITEMS: 'PREPARING ITEMS',
  RELEASING: 'RELEASING',

  //sales transfer
  PENDING_SALES_TRANSFER: 'PENDING SALES TRANSFER',
  SALES_TRANSFER_REQUEST: 'SALES TRANSFER REQUEST',
  SALES_TRANSFER_ON_GOING: 'SALES TRANSFER ON GOING',
  SALES_TRANSFER_COMPLETE: 'SALES TRANSFER COMPLETE',
  IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER: 'IN HOUSE DELIVERY FOR SALES TRANSFER',
  SALES_TRANSFER_RECEIVING: 'SALES TRANSFER RECEIVING',
  SALES_TRANSFER_RELEASING: 'SALES TRANSFER RELEASING',
  SALES_TRANSFER_DISPATCHING: 'SALES TRANSFER DISPATCHING',
  SALES_TRANSFER_BRANCH_RECEIVED: 'SALES TRANSFER BRANCH',

  TESTING: 'TESTING',
  ON_QUEUE: 'ON QUEUE',
  BUILDING: 'BUILDING',

  //SUPERIOR/OWNER
  RMA_CHANGED_ITEM: 'RMA CHANGED ITEM',
  CANCELLED: 'CANCELLED',

  //Already handed to EU
  COMPLETED: 'COMPLETED'
};

export const superiorTapTapRoles = [
  'owner',
  'Owner',
  'Branch Supervisor',
  'Branch OIC'
];

export const taptapOptionsStatusesV2 = [
  // ===== SALES / CASHIER — lightBlue[800] =====
  {
    key: 'for_payment',
    label: taptapStatuses.FOR_PAYMENT,
    value: taptapStatuses.FOR_PAYMENT,
    bgColor: colors.lightBlue[800]
  },

  // ===== ACCOUNTING / ECOMM — pink[800] =====
  {
    key: 'online_fund_transfer',
    label: taptapStatuses.ONLINE_FUND_TRANSFER,
    value: taptapStatuses.ONLINE_FUND_TRANSFER,
    bgColor: colors.pink[800]
  },
  {
    key: 'payment_collection',
    label: taptapStatuses.PAYMENT_COLLECTION,
    value: taptapStatuses.PAYMENT_COLLECTION,
    bgColor: colors.pink[800]
  },

  // ===== WAREHOUSE — amber[800] =====
  {
    key: 'done_payment',
    label: taptapStatuses.DONE_PAYMENT,
    value: taptapStatuses.DONE_PAYMENT,
    bgColor: colors.amber[800]
  },

  {
    key: 'reserved',
    label: taptapStatuses.RESERVED,
    value: taptapStatuses.RESERVED,
    bgColor: colors.amber[800]
  },
  {
    key: 'preparing_items',
    label: taptapStatuses.PREPARING_ITEMS,
    value: taptapStatuses.PREPARING_ITEMS,
    bgColor: colors.amber[800]
  },
  {
    key: 'releasing',
    label: taptapStatuses.RELEASING,
    value: taptapStatuses.RELEASING,
    bgColor: colors.amber[800]
  },
  {
    key: 'for_packing',
    label: taptapStatuses.FOR_PACKING,
    value: taptapStatuses.FOR_PACKING,
    bgColor: colors.amber[800]
  },
  {
    key: 'ready_for_pickup',
    label: taptapStatuses.READY_FOR_PICKUP,
    value: taptapStatuses.READY_FOR_PICKUP,
    bgColor: colors.amber[800]
  },
  {
    key: 'ready_for_delivery',
    label: taptapStatuses.READY_FOR_DELIVERY,
    value: taptapStatuses.READY_FOR_DELIVERY,
    bgColor: colors.amber[800]
  },
  {
    key: 'rma_changed_item',
    label: taptapStatuses.RMA_CHANGED_ITEM,
    value: taptapStatuses.RMA_CHANGED_ITEM,
    bgColor: colors.amber[800]
  },
  {
    key: 'pending_sales_transfer',
    label: taptapStatuses.PENDING_SALES_TRANSFER,
    value: taptapStatuses.PENDING_SALES_TRANSFER,
    bgColor: colors.amber[800]
  },
  {
    key: 'sales_transfer_request',
    label: taptapStatuses.SALES_TRANSFER_REQUEST,
    value: taptapStatuses.SALES_TRANSFER_REQUEST,
    bgColor: colors.amber[800]
  },
  {
    key: 'in_house_delivery_for_sales_transfer',
    label: taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
    value: taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
    bgColor: colors.amber[800]
  },
  {
    key: 'sales_transfer_receiving',
    label: taptapStatuses.SALES_TRANSFER_RECEIVING,
    value: taptapStatuses.SALES_TRANSFER_RECEIVING,
    bgColor: colors.amber[800]
  },
  {
    key: 'sales_transfer_releasing',
    label: taptapStatuses.SALES_TRANSFER_RELEASING,
    value: taptapStatuses.SALES_TRANSFER_RELEASING,
    bgColor: colors.amber[800]
  },
  {
    key: 'sales_transfer_dispatching',
    label: taptapStatuses.SALES_TRANSFER_DISPATCHING,
    value: taptapStatuses.SALES_TRANSFER_DISPATCHING,
    bgColor: colors.amber[800]
  },
  {
    key: 'sales_transfer_branch_received',
    label: taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
    value: taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
    bgColor: colors.amber[800]
  },

  // ===== TECHNICAL — teal[800] =====
  {
    key: 'on_queue',
    label: taptapStatuses.ON_QUEUE,
    value: taptapStatuses.ON_QUEUE,
    bgColor: colors.teal[800]
  },
  {
    key: 'testing',
    label: taptapStatuses.TESTING,
    value: taptapStatuses.TESTING,
    bgColor: colors.teal[800]
  },
  {
    key: 'building',
    label: taptapStatuses.BUILDING,
    value: taptapStatuses.BUILDING,
    bgColor: colors.teal[800]
  },

  // ===== SUPERIOR / OIC =====
  {
    key: 'completed',
    label: taptapStatuses.COMPLETED,
    value: taptapStatuses.COMPLETED,
    bgColor: colors.green[800]
  },
  {
    key: 'refund',
    label: taptapStatuses.REFUND,
    value: taptapStatuses.REFUND,
    bgColor: colors.pink[800]
  },
  {
    key: 'hold',
    label: taptapStatuses.HOLD,
    value: taptapStatuses.HOLD,
    bgColor: colors.grey[700]
  },
  {
    key: 'cancelled',
    label: taptapStatuses.CANCELLED,
    value: taptapStatuses.CANCELLED,
    bgColor: colors.red[800]
  }
];

export const departmentTaptapState = [
  {
    department: 'SALES DEPT',
    roles: ['Offline Sales', 'Sales Associate', 'Sales Supervisor'],
    status_option: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.RESERVED,
      taptapStatuses.COMPLETED
    ]
  },
  {
    department: 'ACCOUNTING DEPT',
    roles: ['Accounting Staff', 'Cashier'],
    status_option: [
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.REFUND,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE
    ]
  },
  {
    department: 'WAREHOUSE DEPT',
    roles: ['Warehouse Staff', 'Warehouse Supervisor'],
    status_option: [
      taptapStatuses.PREPARING_ITEMS, //picking
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.RESERVED,

      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,

      taptapStatuses.TESTING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.READY_FOR_PICKUP,

      taptapStatuses.SALES_TRANSFER_RECEIVING,
      taptapStatuses.SALES_TRANSFER_RELEASING,
      taptapStatuses.SALES_TRANSFER_DISPATCHING,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },
  {
    department: 'TECHNICAL DEPT',
    roles: ['Technical Associate', 'Technical Service Associate'],
    status_option: [
      taptapStatuses.TESTING,
      taptapStatuses.BUILDING,
      taptapStatuses.RESERVED,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },
  {
    department: 'SUPERIOR',
    roles: superiorTapTapRoles,
    status_option: Object.values(taptapStatuses)
  }
];

export const taptapDashboardViewPermissions: {
  [key: string]: PermissionApiName;
} = {
  SALES: 'can_view_taptap_sales_dashboard',
  CASHIER: 'can_view_taptap_cashier_dashboard',
  ACCOUNTING: 'can_view_taptap_accounting_dashboard',
  AFTER_CARE: 'can_view_after_care_dashboard',
  BUILD: 'can_view_taptap_build_dashboard',
  WAREHOUSE: 'can_view_taptap_warehouse_dashboard',
  ALL: 'can_view_all_taptap_dashboard'
};

//GINAGAMIT TO IDENTIFY ANONG STATUSES LANG ANG PWEDENG GAMITIN NG EACH DEPARTMENT
export const departmentTaptapPermissionState = [
  {
    department: 'SALES DEPT',
    permissions: [taptapDashboardViewPermissions.SALES],
    status_option: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.RESERVED,
      taptapStatuses.PAYMENT_COLLECTION,
      // taptapStatuses.DONE_PAYMENT,
      taptapStatuses.COMPLETED
    ]
  },
  {
    department: 'CASHIER DEPT',
    permissions: [taptapDashboardViewPermissions.CASHIER],
    status_option: [
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PAYMENT_COLLECTION,
      taptapStatuses.COMPLETED
    ]
  },
  {
    department: 'ACCOUNTING DEPT', //ECOMM COORDINATOR NA TO
    permissions: [taptapDashboardViewPermissions.ACCOUNTING],
    status_option: [
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.REFUND,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PAYMENT_COLLECTION,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },
  {
    department: 'AFTER CARE DEPT',
    permissions: [taptapDashboardViewPermissions.AFTER_CARE],
    status_option: [taptapStatuses.COMPLETED]
  },
  {
    department: 'WAREHOUSE DEPT',
    permissions: [taptapDashboardViewPermissions.WAREHOUSE],
    status_option: [
      taptapStatuses.FOR_PAYMENT, //for sales transfer transition
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.PENDING_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_REQUEST,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.TESTING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.PAYMENT_COLLECTION,
      taptapStatuses.SALES_TRANSFER_RECEIVING,
      taptapStatuses.SALES_TRANSFER_RELEASING,
      taptapStatuses.SALES_TRANSFER_DISPATCHING,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },
  {
    department: 'TECHNICAL DEPT',
    permissions: [taptapDashboardViewPermissions.BUILD],
    status_option: [
      taptapStatuses.TESTING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.RESERVED,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },
  {
    department: 'ALL',
    permissions: [taptapDashboardViewPermissions.ALL],
    status_option: Object.values(taptapStatuses)
  }
];

//Filter map view only
// eslint-disable-next-line no-undef
export const quickViewDepartmentMap: Record<string, string> = {
  'SALES VIEW': 'SALES DEPT',
  CASHIER: 'ACCOUNTING DEPT',
  RELEASING: 'WAREHOUSE DEPT',
  'FOR BUILD': 'TECHNICAL DEPT'
};

// eslint-disable-next-line no-undef
export const STATUS_BY_VIEW: any = {
  [quickFilterViewsLabels.ALL]: Object.values(taptapStatuses),
  [quickFilterViewsLabels.AFTER_CARE_QA]: [taptapStatuses.COMPLETED],
  'SALES VIEW': [
    taptapStatuses.FOR_PAYMENT,
    taptapStatuses.READY_FOR_PICKUP,
    taptapStatuses.PAYMENT_COLLECTION,
    taptapStatuses.COMPLETED
  ],
  CASHIER: [
    taptapStatuses.DONE_PAYMENT,
    taptapStatuses.REFUND,
    taptapStatuses.PREPARING_ITEMS,
    taptapStatuses.PAYMENT_COLLECTION
  ],
  'FOR BUILD': [
    taptapStatuses.TESTING,
    taptapStatuses.ON_QUEUE,
    taptapStatuses.BUILDING,
    taptapStatuses.COMPLETED
  ],
  RELEASING: [
    taptapStatuses.READY_FOR_DELIVERY,
    taptapStatuses.PAYMENT_COLLECTION,
    taptapStatuses.DONE_PAYMENT,
    taptapStatuses.PREPARING_ITEMS,
    taptapStatuses.RELEASING,
    taptapStatuses.FOR_PACKING,
    taptapStatuses.READY_FOR_PICKUP,
    taptapStatuses.READY_FOR_DELIVERY,
    taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
    taptapStatuses.SALES_TRANSFER_RECEIVING,
    taptapStatuses.SALES_TRANSFER_RELEASING,
    taptapStatuses.SALES_TRANSFER_DISPATCHING,
    taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
    taptapStatuses.COMPLETED
  ],
  [quickFilterViewsLabels.SALES_TRANSFER]: [
    taptapStatuses.PENDING_SALES_TRANSFER,
    taptapStatuses.SALES_TRANSFER_REQUEST,
    taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
    taptapStatuses.SALES_TRANSFER_RECEIVING,
    taptapStatuses.SALES_TRANSFER_RELEASING
  ]
};

/**
 * This is sales transfer flow custom scenario
 * naka base lang din sa:
 * service type, courier, and source
 */
const salesTransferBaseFlow = [
  taptapStatuses.PENDING_SALES_TRANSFER,
  taptapStatuses.FOR_PAYMENT,
  taptapStatuses.DONE_PAYMENT,
  taptapStatuses.PREPARING_ITEMS,
  taptapStatuses.RELEASING,
  taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
  taptapStatuses.SALES_TRANSFER_RECEIVING,
  taptapStatuses.SALES_TRANSFER_RELEASING
];

// Sales transfer maintenance guide:
// 1. Keep common requestor/requestee handoff statuses in salesTransferBaseFlow.
// 2. Add build-only technical statuses in salesTransferTechnicalFlow.
// 3. Adjust pickup vs delivery endings in resolveSalesTransferDeliveryFlow.
// 4. Add supported couriers/sources/service types in the arrays below.
// createSalesTransferScenarios() generates scenarioState entries for every combination.
const salesTransferTechnicalFlow = [
  taptapStatuses.ON_QUEUE,
  taptapStatuses.BUILDING
];

const resolveSalesTransferDeliveryFlow = (courier: string) =>
  courier === taptapCouriers.PICK_UP
    ? [taptapStatuses.READY_FOR_PICKUP, taptapStatuses.COMPLETED]
    : [
        taptapStatuses.FOR_PACKING,
        taptapStatuses.READY_FOR_DELIVERY,
        taptapStatuses.COMPLETED
      ];

const resolveSalesTransferStatusFlow = ({
  courier,
  serviceType
}: {
  courier: string;
  serviceType: string;
}) => [
  ...salesTransferBaseFlow,
  ...(serviceType === taptapServiceType.BUILD_SALES_TRANSFER
    ? salesTransferTechnicalFlow
    : []),
  ...resolveSalesTransferDeliveryFlow(courier)
];

const salesTransferCouriers = [
  taptapCouriers.PICK_UP,
  taptapCouriers.TECHOUT,
  taptapCouriers.JNT,
  taptapCouriers.LALAMOVE
];

const salesTransferSources = [taptapSourceV2.ONLINE, taptapSourceV2.WALK_IN];

const salesTransferServiceTypes = [
  taptapServiceType.BUILD_SALES_TRANSFER,
  taptapServiceType.PARTS_OUT_SALES_TRANSFER
];

const createSalesTransferScenarioId = ({
  courier,
  serviceType,
  source
}: {
  courier: string;
  serviceType: string;
  source: string;
}) =>
  [
    serviceType === taptapServiceType.BUILD_SALES_TRANSFER
      ? 'BUILD'
      : 'PARTS_OUT',
    'SALES_TRANSFER',
    source === taptapSourceV2.ONLINE ? 'ON' : 'WI',
    courier.replace(/[^A-Z0-9]+/g, '_')
  ].join('_');

const createSalesTransferScenarios = () =>
  salesTransferSources.flatMap((source) =>
    salesTransferServiceTypes.flatMap((serviceType) =>
      salesTransferCouriers.map((courier) => ({
        id: createSalesTransferScenarioId({ courier, serviceType, source }),
        source,
        serviceType,
        courier,
        statusFlow: resolveSalesTransferStatusFlow({ courier, serviceType })
      }))
    )
  );

export const scenarioState = [
  // ─── WALK IN ───────────────────────────────────────────────────────────────

  {
    id: 'WI_BUILD_PICKUP',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - Picking items (implied)
      taptapStatuses.RELEASING, // 4 - Warehouse
      taptapStatuses.ON_QUEUE, // 4 - WAREHOUSE
      taptapStatuses.BUILDING, // 5 - Technical
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 6 - EU
    ]
  },

  {
    id: 'WI_BUILD_ADTNL_PURCHASE',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.ADDITIONAL_PURCHASE,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.READY_FOR_PICKUP, //SALES
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_PARTS_PICKUP',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 4 - Warehouse
      taptapStatuses.TESTING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED // 5 - End User
    ]
  },

  {
    id: 'WI_BUILD_TECHOUT',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY, //WAREHOUSE
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_BUILD_LALAMOVE',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY, //WAREHOUSE
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_BUILD_JNT',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY, //WAREHOUSE
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_PARTS_JNT',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 4 - Warehouse
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 7 - End User
    ]
  },

  {
    id: 'WI_PARTS_TECHOUT',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 4 - Warehouse
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 7 - End User
    ]
  },

  {
    id: 'WI_PARTS_LALAMOVE',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 4 - Warehouse
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 7 - End User
    ]
  },

  {
    id: 'WI_PARTS_LAPTOP_TESTING_PICKUP',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.LAPTOP,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - WAREHOUSE
      taptapStatuses.RELEASING, // 4 - WAREHOUSE
      taptapStatuses.TESTING, // 5 - Technical
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED // 6- End User
    ]
  },

  {
    id: 'WI_PARTS_LAPTOP_TESTING_TECHOUT',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.LAPTOP,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - WAREHOUSE
      taptapStatuses.RELEASING, // 4 - WAREHOUSE
      taptapStatuses.TESTING, // 5 - Technical
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 6- End User
    ]
  },

  {
    id: 'WI_PARTS_LAPTOP_TESTING_JNT',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.LAPTOP,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - WAREHOUSE
      taptapStatuses.RELEASING, // 4 - WAREHOUSE
      taptapStatuses.TESTING, // 5 - Technical
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 6- End User
    ]
  },

  {
    id: 'WI_PARTS_LAPTOP_TESTING_LALAMOVE',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.LAPTOP,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - WAREHOUSE
      taptapStatuses.RELEASING, // 4 - WAREHOUSE
      taptapStatuses.TESTING, // 5 - Technical
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 6- End User
    ]
  },

  {
    id: 'WI_PARTS_MONITOR_TESTING_LALAMOVE',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING,
      taptapStatuses.TESTING, // 4 - Technical
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 8 - End User
    ]
  },

  {
    id: 'WI_PARTS_MONITOR_TESTING_PICKUP',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 5 - Warehouse
      taptapStatuses.TESTING, // 4 - Technical
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED // 8 - End User
    ]
  },

  {
    id: 'WI_PARTS_MONITOR_TESTING_TECHOUT',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 5 - Warehouse
      taptapStatuses.TESTING, // 4 - Technical
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 8 - End User
    ]
  },

  {
    id: 'WI_PARTS_MONITOR_TESTING_JNT',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 5 - Warehouse
      taptapStatuses.TESTING, // 4 - Technical
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 8 - End User
    ]
  },

  // ─── WALK IN RMA ───────────────────────────────────────────────────────────

  {
    id: 'WI_BUILD_PICKUP_RMA_DIFF_ADDL_COST',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.BUILD_RMA_DIFFERENT_PC_PARTS_WT_ADD_COST,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.RMA_CHANGED_ITEM, //  Superior approves
      taptapStatuses.FOR_PAYMENT, // Sales (additional cost)
      taptapStatuses.DONE_PAYMENT, //  Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING, // Technical rebuild
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED // End User
    ]
  },

  {
    id: 'WI_BUILD_PICKUP_RMA_SAME_PARTS',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.BUILD_RMA_SAME_PC_PARTS,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.RMA_CHANGED_ITEM,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_BUILD_PICKUP_RMA_DIFF_REFUND',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.BUILD_RMA_DIFFERENT_PC_PARTS_WT_REFUND,
    courier: taptapCouriers.PICK_UP,
    modifier: 'RMA_DIFF_PARTS_REFUND',
    statusFlow: [
      taptapStatuses.RMA_CHANGED_ITEM,
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.REFUND,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  // ─── WALK IN SALES TRANSFER ────────────────────────────────────────────────

  {
    id: 'WI_BUILD_PICKUP_ST_RECEIVING',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.BUILD_TRANSFER_BRANCH_RECEIVING,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_RECEIVING,
      taptapStatuses.RELEASING,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_BUILD_PICKUP_ST_DISPATCHING',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.BUILD_TRANSFER_BRANCH_DISPATCHING,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_DISPATCHING,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_PARTS_PICKUP_ST_RECEIVING',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.PARTS_OUT_TRANSFER_BRANCH_RECEIVING,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_RECEIVING,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_PARTS_PICKUP_ST_DISPATCHING',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS, // 1 - Warehouse
      taptapStatuses.SALES_TRANSFER_DISPATCHING, // 2 - Warehouse (implied)
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER, // 3 - Warehouse
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED, // 4 - Confirmation
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_PICKUP_ST',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.SALES_TRANSFER,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_TECHOUT_ST',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.SALES_TRANSFER,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_LALAMOVE_ST',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.SALES_TRANSFER,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_JNT_ST',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.SALES_TRANSFER,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'WI_BUILD_LALAMOVE_ST_RECEIVING',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.BUILD_TRANSFER_BRANCH_RECEIVING,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER, // 3 - Warehouse
      taptapStatuses.SALES_TRANSFER_RECEIVING, // 4 - Warehouse
      taptapStatuses.RELEASING, // 5 - Logistic
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED // 6 - End User (implied)
    ]
  },

  {
    id: 'WI_BUILD_LALAMOVE_ST_DISPATCHING',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.BUILD_TRANSFER_BRANCH_DISPATCHING,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS, // 1 - Warehouse
      taptapStatuses.SALES_TRANSFER_DISPATCHING, // 2 - Warehouse (implied)
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER, // 3 - Warehouse
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED, // 4 - Confirmation
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_PICKUP_ST',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.SALES_TRANSFER,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_TECHOUT_ST',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.SALES_TRANSFER,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_LALAMOVE_ST',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.SALES_TRANSFER,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_JNT_ST',
    source: taptapSourceV2.WALK_IN,
    serviceType: taptapServiceType.SALES_TRANSFER,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  // ─── ONLINE (FB | VIBER | ECOMM) ───────────────────────────────────────────────────

  {
    id: 'ON_BUILD_PICKUP',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_BUILD_JNT',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_BUILD_TECHOUT',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_BUILD_LALAMOVE',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_PARTS_PICKUP',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - E-Com Dashboard
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS, // 4 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 5 - Warehouse
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED // 6 - End User
    ]
  },

  {
    id: 'ON_PARTS_TECHOUT',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_PARTS_LALAMOVE',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_PARTS_LAPTOP_TESTING_PICKUP',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.LAPTOP,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT, // 1 - Sales
      taptapStatuses.DONE_PAYMENT, // 2 - E-Com Dashboard
      taptapStatuses.ONLINE_FUND_TRANSFER, // 3 - Online Fund Transfer
      taptapStatuses.PREPARING_ITEMS, // 4 - WAREHOUSE
      taptapStatuses.RELEASING, // 5 - WAREHOUSE
      taptapStatuses.TESTING, // 6 - Technical
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  // ─── ONLINE ────────────────────────────────────────────────────────────────

  {
    id: 'ON_PARTS_JNT',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_PARTS_MONITOR_TESTING_LALAMOVE',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.TESTING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  // ─── ONLINE RMA ─────────────────────────────────────────────────────────────

  {
    id: 'ON_BUILD_PICKUP_RMA_DIFF_ADDL_COST',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.BUILD_RMA_DIFFERENT_PC_PARTS_WT_ADD_COST,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.RMA_CHANGED_ITEM,
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_MONITOR_PICKUP',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 5 - Warehouse
      taptapStatuses.TESTING, // 4 - Technical
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED // 8 - End User
    ]
  },

  {
    id: 'ON_MONITOR_TECHOUT',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT, // 2 - Cashier
      taptapStatuses.PREPARING_ITEMS, // 3 - Warehouse (Picking)
      taptapStatuses.RELEASING, // 5 - Warehouse
      taptapStatuses.TESTING, // 4 - Technical
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED // 8 - End User
    ]
  },

  {
    id: 'ON_BUILD_PICKUP_RMA_SAME_PARTS',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.BUILD_RMA_SAME_PC_PARTS,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.RMA_CHANGED_ITEM,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_BUILD_PICKUP_RMA_DIFF_REFUND',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.BUILD_RMA_DIFFERENT_PC_PARTS_WT_REFUND,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.RMA_CHANGED_ITEM,
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.REFUND,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  // ─── ONLINE SALES TRANSFER ──────────────────────────────────────────────────

  {
    id: 'ON_BUILD_PICKUP_ST_RECEIVING',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.BUILD_TRANSFER_BRANCH_RECEIVING,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_RECEIVING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_BUILD_PICKUP_ST_DISPATCHING',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.BUILD_TRANSFER_BRANCH_DISPATCHING,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_DISPATCHING,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_PARTS_PICKUP_ST_RECEIVING',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.PARTS_OUT_TRANSFER_BRANCH_RECEIVING,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_RECEIVING,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_PARTS_PICKUP_ST_DISPATCHING',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.PARTS_OUT_TRANSFER_BRANCH_DISPATCHING,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_DISPATCHING,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_BUILD_LALAMOVE_ST_RECEIVING',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.BUILD_TRANSFER_BRANCH_RECEIVING,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.FOR_PAYMENT,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_RECEIVING,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ON_BUILD_LALAMOVE_ST_DISPATCHING',
    source: taptapSourceV2.ONLINE,
    serviceType: taptapServiceType.BUILD_TRANSFER_BRANCH_DISPATCHING,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.SALES_TRANSFER_DISPATCHING,
      taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
      taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
      taptapStatuses.COMPLETED
    ]
  },

  // ─── ECOMM ─────────────────────────────────────────────────────────────────
  // Same flows as ONLINE but source = ECOMM, without DONE_ONLINE_PAYMENT.

  {
    id: 'ECOM_BUILD_PICKUP',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  /**
   * Releasing/warehouse
    - for reserve
    - for preparing items 
    - proceed to reserved   
   */
  {
    id: 'ECOM_PARTS_PICKUP',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_PARTS_JNT',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_PARTS_LALAMOVE',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_BUILD_TECHOUT',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_PARTS_TECHOUT',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.PARTS_OUT,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_BUILD_LALAMOVE',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_BUILD_JNT',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_PARTS_LAPTOP_TESTING_PICKUP',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.LAPTOP,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.TESTING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_PARTS_LAPTOP_TESTING_JNT',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.LAPTOP,
    courier: taptapCouriers.JNT,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.TESTING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_PICKUP_MONITOR',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.PICK_UP,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.TESTING,
      taptapStatuses.READY_FOR_PICKUP,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_MONITOR_TECHOUT',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.TECHOUT,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.TESTING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_MONITOR_LALAMOVE',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.MONITOR,
    courier: taptapCouriers.LALAMOVE,
    statusFlow: [
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.DONE_PAYMENT,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.TESTING,
      taptapStatuses.FOR_PACKING,
      taptapStatuses.READY_FOR_DELIVERY,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_CANCEL',
    source: taptapSourceV2.ECOMM,
    serviceType: null,
    courier: null,
    statusFlow: [taptapStatuses.ONLINE_FUND_TRANSFER, taptapStatuses.CANCELLED]
  },

  {
    id: 'ECOM_BUILD_PICKUP_RMA_DIFF_ADDL_COST',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.PICK_UP,
    modifier: 'RMA_DIFF_PARTS_ADDL_COST',
    statusFlow: [
      // RMA loop
      taptapStatuses.RMA_CHANGED_ITEM,
      taptapStatuses.ONLINE_FUND_TRANSFER,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_BUILD_PICKUP_RMA_SAME_PARTS',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.PICK_UP,
    modifier: 'RMA_SAME_PARTS',
    statusFlow: [
      // RMA loop
      taptapStatuses.RMA_CHANGED_ITEM,
      taptapStatuses.ON_QUEUE,
      taptapStatuses.BUILDING,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },

  {
    id: 'ECOM_BUILD_PICKUP_RMA_DIFF_REFUND',
    source: taptapSourceV2.ECOMM,
    serviceType: taptapServiceType.FOR_BUILD,
    courier: taptapCouriers.PICK_UP,
    modifier: 'RMA_DIFF_PARTS_REFUND',
    statusFlow: [
      // RMA + refund
      taptapStatuses.RMA_CHANGED_ITEM,
      taptapStatuses.REFUND,
      taptapStatuses.BUILDING,
      taptapStatuses.PREPARING_ITEMS,
      taptapStatuses.RELEASING,
      taptapStatuses.COMPLETED
    ]
  },

  ...createSalesTransferScenarios()
];

//===== PARA SA MGA QUICK FILTERS FOR V2

const quickFilterSalesViewConditionsV2: TapTapFiltersV2 = {
  logic: 'and',
  conditions: []
};

const quickFilterForCashierV2: TapTapFiltersV2 = {
  logic: 'or',
  conditions: [
    {
      field: taptapCustomerField.STATUS,
      operator: 'in',
      value: [
        taptapStatuses.FOR_PAYMENT,
        taptapStatuses.REFUND,
        taptapStatuses.ONLINE_FUND_TRANSFER,
        taptapStatuses.RESERVED,
        taptapStatuses.HOLD,
        taptapStatuses.CANCELLED
      ]
    },
    {
      field: taptapCustomerField.BALANCE,
      operator: 'gt',
      value: 0.00001
    },
    {
      field: taptapCustomerField.TAG,
      operator: 'eq',
      value: TAG_AS_RESERVED
    }
  ]
  // Moved in thunk to be dynamic based on user assigned branch
  // queryBuilderExtraConfig: {
  //   dynamicChain: [
  //     {
  //       method: 'or',
  //       value: 'branch_released.eq.LPC,kind_of_sales_transfer.ilike.%LPC%'
  //     }
  //   ]
  // }
};

const quickFilterForAccounting: TapTapFiltersV2 = {
  logic: 'or',
  conditions: [
    {
      field: taptapCustomerField.STATUS,
      operator: 'in',
      value: [
        taptapStatuses.ONLINE_FUND_TRANSFER,
        taptapStatuses.RESERVED,
        taptapStatuses.HOLD,
        taptapStatuses.CANCELLED
      ]
    },
    {
      field: taptapCustomerField.TAG,
      operator: 'eq',
      value: TAG_AS_RESERVED
    }
  ]
  // Moved in thunk to be dynamic based on user assigned branch
  // queryBuilderExtraConfig: {
  //   dynamicChain: [
  //     {
  //       method: 'or',
  //       value: 'branch_released.eq.LPC,kind_of_sales_transfer.ilike.%LPC%'
  //     }
  //   ]
  // }
};

const quickFilterForBuildConditionsV2: TapTapFiltersV2 = {
  logic: 'and',
  conditions: [
    {
      field: taptapCustomerField.STATUS,
      operator: 'in',
      value: [
        taptapStatuses.ON_QUEUE,
        taptapStatuses.TESTING,
        taptapStatuses.BUILDING,
        taptapStatuses.READY_FOR_PICKUP,
        taptapStatuses.HOLD,
        taptapStatuses.CANCELLED
      ]
    }
    // {
    //   field: taptapCustomerField.SERVICE_TYPE,
    //   operator: 'in',
    //   value: [taptapServiceType.FOR_BUILD]
    // }
  ]
};

const quickFilterForReleasingV2: TapTapFiltersV2 = {
  logic: 'and',
  conditions: [
    {
      field: taptapCustomerField.STATUS,
      operator: 'in',
      value: [
        taptapStatuses.DONE_PAYMENT,
        taptapStatuses.RESERVED,
        taptapStatuses.PREPARING_ITEMS, //picking
        taptapStatuses.RELEASING,

        taptapStatuses.FOR_PACKING,
        taptapStatuses.READY_FOR_PICKUP,
        taptapStatuses.READY_FOR_DELIVERY,

        taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
        taptapStatuses.SALES_TRANSFER_RECEIVING,
        taptapStatuses.SALES_TRANSFER_DISPATCHING,
        taptapStatuses.SALES_TRANSFER_BRANCH_RECEIVED,
        taptapStatuses.HOLD,
        taptapStatuses.CANCELLED
      ]
    }
  ]
};

const quickFilterForSalesTransferV2: TapTapFiltersV2 = {
  logic: 'and',
  conditions: [
    {
      field: taptapCustomerField.STATUS,
      operator: 'in',
      value: [
        taptapStatuses.PENDING_SALES_TRANSFER,
        taptapStatuses.SALES_TRANSFER_REQUEST,
        taptapStatuses.IN_HOUSE_DELIVERY_FOR_SALES_TRANSFER,
        taptapStatuses.SALES_TRANSFER_RECEIVING,
        taptapStatuses.SALES_TRANSFER_RELEASING
      ]
    }
  ]
};

const quickFilterAfterCareQAConditionsV2: TapTapFiltersV2 = {
  logic: 'and',
  conditions: [
    {
      field: taptapCustomerField.STATUS,
      operator: 'in',
      value: [taptapStatuses.COMPLETED]
    }
  ]
};

export const quickFilterViewsChoicesV2: TapTapQuickFilterView[] = [
  {
    id: 'sales_view',
    label: quickFilterViewsLabels.SALES_VIEW,
    filters: quickFilterSalesViewConditionsV2,
    permission: taptapDashboardViewPermissions.SALES,
    allowed_roles: ['Offline Sales', 'Sales Associate', 'Sales Supervisor'],
    sort: [
      {
        field: 'created_at',
        direction: 'ASC'
      }
    ]
  },

  {
    id: 'cashier',
    label: quickFilterViewsLabels.CASHIER,
    filters: quickFilterForCashierV2,
    defaultColumns: quickFilterCashierDefaultColumns,
    permission: taptapDashboardViewPermissions.CASHIER,
    allowed_roles: ['Cashier'],
    sort: [
      {
        field: 'created_at',
        direction: 'ASC'
      }
    ]
  },

  {
    id: 'payment_verification',
    label: quickFilterViewsLabels.PAYMENT_VERIFICATION,
    filters: quickFilterForAccounting,
    // defaultColumns: quickFilterCashierDefaultColumns,
    permission: taptapDashboardViewPermissions.ACCOUNTING,
    allowed_roles: ['Accounting Staff', 'Ecomm Coordinator'],
    sort: [
      {
        field: 'created_at',
        direction: 'ASC'
      }
    ]
  },
  {
    id: 'after_care_qa',
    label: quickFilterViewsLabels.AFTER_CARE_QA,
    filters: quickFilterAfterCareQAConditionsV2,
    defaultColumns: quickFilterReleasingDefaultColumns,
    permission: taptapDashboardViewPermissions.AFTER_CARE,
    allowed_roles: ['owner', 'Accounting Staff'],
    sort: [
      {
        field: 'created_at',
        direction: 'ASC'
      }
    ]
  },
  {
    id: 'for_build',
    label: quickFilterViewsLabels.FOR_BUILD,
    filters: quickFilterForBuildConditionsV2,
    defaultColumns: quickFilterForBuildDefaultColumns,
    permission: taptapDashboardViewPermissions.BUILD,
    allowed_roles: ['Technical Associate', 'Technical Service Associate'],
    sort: [
      {
        field: 'created_at',
        direction: 'ASC'
      }
    ]
  },
  // {
  //   id: 'logistics',
  //   label: quickFilterViewsLabels.LOGISTICS,
  //   filters: quickFilterForLogistic,
  //   defaultColumns: quickFilterLogisticsDefaultColumns
  // },
  {
    id: 'releasing',
    label: quickFilterViewsLabels.RELEASING,
    filters: quickFilterForReleasingV2,
    defaultColumns: quickFilterReleasingDefaultColumns,
    permission: taptapDashboardViewPermissions.WAREHOUSE,
    allowed_roles: ['Warehouse Staff', 'Warehouse Supervisor'],
    sort: [
      {
        field: 'created_at',
        direction: 'ASC'
      }
    ]
  },
  {
    id: 'sales_transfer',
    label: quickFilterViewsLabels.SALES_TRANSFER,
    filters: quickFilterForSalesTransferV2,
    defaultColumns: quickFilterReleasingDefaultColumns,
    permission: taptapDashboardViewPermissions.WAREHOUSE,
    allowed_roles: ['Warehouse Staff', 'Warehouse Supervisor'],
    sort: [
      {
        field: 'created_at',
        direction: 'ASC'
      }
    ]
  },
  {
    id: 'all',
    label: quickFilterViewsLabels.ALL,
    filters: taptapCustomerInitialPayload.filters,
    permission: taptapDashboardViewPermissions.ALL,
    allowed_roles: [],
    sort: [
      {
        field: 'created_at',
        direction: 'ASC'
      }
    ]
  }

  // {
  //   id: 'not_completed',
  //   label: quickFilterViewsLabels.NOT_COMPLETED,
  //   filters: quickFilterNotCompleted
  // }
];
